// extracted by mini-css-extract-plugin
export default {"wrapper":"main_wrapper__M6rF9","wrapperLoadGoods":"main_wrapperLoadGoods__vlq3m"};